import { createUseStyles } from '../../theme/theming';

const useCourseStyles = createUseStyles((theme) => {
  return {
    coursesContainer: {
      overflow: 'hidden',
      padding: ({ isMobile } = {}) =>
        isMobile
          ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
          : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      }
      // '& h2,& h3': {
      //   fontWeight: '500',
      //   '& b,& strong': {
      //     fontWeight: '700'
      //   }
      // }
    },

    sectionContainer: {
      margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },

    // coursesCardAndText: {
    //   padding: '70px'
    // },

    coursesText: {
      color: theme?.palette?.font?.secondary,
      fontWeight: '400',
      fontSize: theme.typography.fontSize.subHead,
      lineHeight: '20px',
      textAlign: 'center',
      textTransform: 'uppercase',
      wordBreak: 'break-word'
    },

    coursesHeader: {
      fontSize: theme.typography.fontSize.h2,
      lineHeight: '70px',
      color: theme?.palette?.font?.default,
      marginTop: '8px',
      marginBottom: theme.spacing.margin.tiny,
      textAlign: 'center'
      // overflow: 'hidden',
      // whiteSpace: 'nowrap',
      // textOverflow: 'ellipsis',
      // textAlign: 'center',
      // wordBreak: 'break-word'
    },

    slickContainer: {
      marginRight: '-20px'
    },

    singleCardContainer: {
      display: 'grid',
      gridTemplateColumns: `repeat(3, 320px)`
    },

    singleCard: {
      height: 'calc(100% - 12px)',
      width: 'calc(100% - 24px)',
      margin: '6px 12px',
      position: 'relative',
      background: theme?.palette?.background?.default,
      boxShadow: theme?.shadows?.primary,
      borderRadius: theme?.shape?.borderRadius?.regular,
      display: 'flex',
      flexDirection: 'column'
    },

    cardDetails: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },

    courseCardImg: {
      width: '100%',
      height: '200px',
      position: 'relative',

      borderTopLeftRadius: theme?.shape?.borderRadius?.regular,
      borderTopRightRadius: theme?.shape?.borderRadius?.regular
    },

    courseCardImgThumbnail: {
      borderTopLeftRadius: theme?.shape?.borderRadius?.regular,
      borderTopRightRadius: theme?.shape?.borderRadius?.regular,
      maxWidth: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      minWidth: '100%'
    },

    courseCardData: {
      padding: '20px',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
      //alignItems: 'center',
    },
    courseCardTags: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    courseCardTag: {
      backgroundColor: '#E1EAF6',
      fontSize: '12px',
      color: '#666666',
      margin: '0',
      marginRight: '4px',
      padding: '4px',
      borderRadius: '2px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    courseCardName: {
      color: theme?.palette?.font?.default,
      fontWeight: '700',
      fontSize: theme.typography.fontSize.h5,
      lineHeight: '32px',
      wordBreak: 'break-word',
      padding: '12px 0px',
      textAlign: 'left',
      display: 'inline-block'
      // overflow: 'hidden',
      // whiteSpace: 'nowrap',
      // textOverflow: 'ellipsis'
    },
    courseCardDiscount: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontSize: theme.typography.fontSize.body,
      color: theme?.palette?.font?.primary,
      '& img': {
        marginRight: '5px'
      }
    },
    courseCardFooter: {
      borderTop: '1px solid #E1EAF6',
      marginTop: '12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 0 0 4px'
    },
    courseCardPrice: {
      fontSize: theme.typography.fontSize.h5,
      fontWeight: '700'
    },

    coursesAnchorTag: {
      textDecoration: 'none !important'
    },
    courseCardStrikePrice: {
      fontSize: '14px',
      lineHeight: '13px',
      color: '#FE9B0E',
      '& span': {
        marginRight: '8px',
        textDecorationLine: 'line-through',
        color: 'black'
      }
    },
    courseCardBuyBtn: {
      cursor: 'pointer',
      background: theme?.colors?.ctaColor,
      color: theme?.colors?.CtaTextColor,
      padding: '8px 16px',
      fontWeight: theme.typography.fontWeight.bold,
      cursor: 'pointer',
      borderRadius: theme.shape.borderRadius.regular
    },
    buttonContainer: {
      display: 'flex',
      width: '120px',
      justifyContent: 'space-between',
      margin: '36px auto 81px auto'
    },
    shimmerContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },

    shine: {
      background: '#f6f7f8',
      height: '400px',
      width: '100%',
      marginRight: '20px',
      borderRadius: theme?.shape?.borderRadius?.regular,
      backgroundImage:
        'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      display: 'inline-block',
      position: 'relative',
      animationDuration: '1s',
      animationFillMode: 'forwards',
      animationIterationCount: 'infinite',
      animationName: '$placeholderShimmer',
      animationTimingFunction: 'linear'
    },
    '@keyframes placeholderShimmer': {
      '0%': { backgroundPosition: '-468px 0' },
      '100%': { backgroundPosition: '468px 0' }
    },

    '@media (max-width: 768px)': {
      coursesContainer: {
        //background: theme?.palette?.background?.primary
      },
      coursesCardAndText: {
        // padding: '70px 30px'
      },
      singleCardContainer: {
        gridTemplateColumns: '1fr'
      },
      size: {
        margin: '0'
      },

      courseCardPrice: {
        fontSize: '24px'
      },

      coursesHeader: {
        // fontSize: '24px',
        lineHeight: '36px',
        color: theme?.palette?.font?.default,
        margin: '0px 0 12px 0',
        textAlign: 'center'
        // overflow: 'hidden',
        // whiteSpace: 'nowrap',
        // textOverflow: 'ellipsis'
      },

      singleCard: {
        margin: '6px 2px'
        // width: 'calc(100% - 12px)'
      }
    }
  };
});

export default useCourseStyles;
